// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMoneyTransferResponseDto
 */
export interface IMoneyTransferResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IMoneyTransferResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IMoneyTransferResponseDto
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IMoneyTransferResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IMoneyTransferResponseDto
     */
    type?: IMoneyTransferResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IMoneyTransferResponseDto
     */
    status?: IMoneyTransferResponseDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IMoneyTransferResponseDtoTypeEnum {
    INDIVIDUAL_DEPOSIT = 'INDIVIDUAL_DEPOSIT',
    BULK_DEPOSIT = 'BULK_DEPOSIT',
    INDIVIDUAL_WITHDRAWAL = 'INDIVIDUAL_WITHDRAWAL',
    BULK_WITHDRAWAL = 'BULK_WITHDRAWAL',
    INDIVIDUAL_FEES = 'INDIVIDUAL_FEES',
    BULK_FEES = 'BULK_FEES'
}
/**
* @export
* @enum {string}
*/
export enum IMoneyTransferResponseDtoStatusEnum {
    CREATED_INTERNAL = 'CREATED_INTERNAL',
    CREATED_EXTERNAL = 'CREATED_EXTERNAL',
    SUCCESSFUL_EXTERNAL = 'SUCCESSFUL_EXTERNAL',
    PENDING_PAYMENT = 'PENDING_PAYMENT',
    PAID = 'PAID',
    FAILED_EXTERNAL = 'FAILED_EXTERNAL'
}


/**
 * Check if a given object implements the IMoneyTransferResponseDto interface.
 */
export function instanceOfIMoneyTransferResponseDto(value: object): value is IMoneyTransferResponseDto {
    return true;
}

export function IMoneyTransferResponseDtoFromJSON(json: any): IMoneyTransferResponseDto {
    return IMoneyTransferResponseDtoFromJSONTyped(json, false);
}

export function IMoneyTransferResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMoneyTransferResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function IMoneyTransferResponseDtoToJSON(json: any): IMoneyTransferResponseDto {
    return IMoneyTransferResponseDtoToJSONTyped(json, false);
}

export function IMoneyTransferResponseDtoToJSONTyped(value?: IMoneyTransferResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'type': value['type'],
        'status': value['status'],
    };
}

